import trackTextDecorationSettingsDialogCanceled from './track-text-decoration-settings-dialog-canceled';
import trackTextDecorationSettingsDialogSubmitted from './track-text-decoration-settings-dialog-submitted';

export default {
  trackTextDecorationSettingsDialogCanceled,
  trackTextDecorationSettingsDialogSubmitted,
};
